enum KeyboardLayout {
    LOWERCASE,
    UPPERCASE,
    CAPS_LOCK,
    SPECIAL,
    NUMBERS
}

export default KeyboardLayout;